import { render, staticRenderFns } from "./PedidosEmTransitoDialog.vue?vue&type=template&id=643e1d16&scoped=true"
import script from "./PedidosEmTransitoDialog.vue?vue&type=script&lang=js"
export * from "./PedidosEmTransitoDialog.vue?vue&type=script&lang=js"
import style0 from "./PedidosEmTransitoDialog.vue?vue&type=style&index=0&id=643e1d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643e1d16",
  null
  
)

export default component.exports